import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

interface TextAreaFieldProps {
  rows?: number;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  [key: string]: any;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  rows = 4,
  placeholder,
  value = '',
  onChange,
  ...props
}) => {
  return (
    <TextArea
      rows={rows}
      placeholder={placeholder}
      value={value}
      onChange={e => onChange?.(e.target.value)}
      {...props}
    />
  );
};
